import { useTranslation } from 'next-i18next';
import React, { DetailedHTMLProps, HTMLAttributes, useState } from 'react';
import Box, { HeaderTheme } from 'src/components/ui-kit/box/box';
import { Media } from 'src/entities/media';
import styles from './maps.module.scss';
import FsLightbox from 'fslightbox-react';

export default function ListingsMaps({
  maps,
  className,
  ...restProps
}: { maps: Array<Media> } & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element {
  const { t } = useTranslation('components:pages:listings:view:maps');
  const [lightboxController, setlightboxController] = useState<{ isOpen: boolean; slide: number }>({
    isOpen: false,
    slide: 0
  });

  const openLightboxOnSlide = (slide: number) => {
    return (): void => setlightboxController({
      isOpen: !lightboxController.isOpen,
      slide
    });
  };

  return (
    <Box
      className={className}
      heading={t('TEXT_PROPERTY_MAP')}
      headingTheme={HeaderTheme.DARK}
      {...restProps}>
      <FsLightbox
        toggler={lightboxController.isOpen}
        sources={maps.map((image) => image.url)}
        types={new Array(maps.length)
          .fill('image')}
        sourceIndex={lightboxController.slide}
      />
      <div className={styles.maps}>
        {maps.map((image, index) => (
          <figure
            key={index}
            className={styles.maps_inner}
            onClick={openLightboxOnSlide(index)}
            role='presentation'>
            <img
              className={styles.maps_image}
              src={image.url}
              alt={image.name} />
          </figure>
        ))}
      </div>
    </Box>
  );
}
